import { render } from "./BookingBarOffer.vue?vue&type=template&id=f06c40e2"
import script from "./BookingBarOffer.vue?vue&type=script&lang=js"
export * from "./BookingBarOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingBarOffer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f06c40e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f06c40e2', __exports__)) {
    api.reload('f06c40e2', __exports__)
  }
  
  module.hot.accept("./BookingBarOffer.vue?vue&type=template&id=f06c40e2", () => {
    api.rerender('f06c40e2', render)
  })

}


export default __exports__